import { FC } from "react";

import { displayOutcomeName } from "./helpers";

import { SectionOutcomeType } from "components/server-types";
import { OutcomeChip } from "mds/components/OutcomeChip";
import { useAppSelector } from "store/index";
import {
  selectCurrentSectionId,
  selectCurrentUserId,
  selectOutcomeById,
  selectSectionOutcomeAverage,
} from "store/selectors";

export const SectionOutcomeAverageScore: FC<{
  sectionOutcome: SectionOutcomeType;
  role?: "heading" | "listitem";
}> = ({ sectionOutcome, role }) => {
  const userId = useAppSelector(selectCurrentUserId);
  const sectionId = useAppSelector(selectCurrentSectionId);
  const outcome = useAppSelector((s) => selectOutcomeById(s, sectionOutcome.outcome_id));
  const averageScore = useAppSelector((s) =>
    selectSectionOutcomeAverage(s, sectionOutcome.id, userId, sectionId),
  );

  return (
    <OutcomeChip role={role} score={averageScore} size="m" title={displayOutcomeName(outcome)} />
  );
};
